import getApiClient from '@/plugins/api-client'
import Vue from 'vue'

export default {
  loadTestimonial () {
    const api = getApiClient(this.$store)
    const testimonialId = this.$route.params.id

    api.get(`testimonials/${testimonialId}`)
      .then(result => {
        this.testimonial = result.data
      })
      .catch(error => {
        this.error = error.response
      })
  },

  save () {
    this.errors = {}
    const api = getApiClient(this.$store)
    const method = this.testimonial.id ? 'patch' : 'post'
    const options = {}

    let endpoint = 'testimonials'

    if (method === 'patch') {
      options.headers = {
        'Content-Type': 'application/merge-patch+json',
      }
      endpoint = this.testimonial['@id']
    }

    const payload = this.testimonial
    if (payload.photo && !payload.photo.match(/data:image\/.*?/g)) {
      delete payload.photo
    }

    api[method](endpoint, payload, options)
      .then(() => {
        this.$store.commit('app/raiseSuccess', 'Depoimento salvo com sucesso')
        this.$router.push({
          name: 'Testimonials',
        })
      })
      .catch(error => {
        if (error.response.status === 422) {
          this.parseErrors(error.response.data)
        }
        this.$store.commit('app/raiseError', 'Falha ao salvar depoimento')
      })
  },

  parseErrors (errors) {
    const self = this

    errors.violations.forEach(violation => {
      Vue.set(self.errors, violation.propertyPath, violation.message)
    })
  },
}
